module.exports = __webpack_public_path__ + "static/img/gift-box-close.b1923012.webp";